/* targa-stock.js — shows the visitor's REAL country in the PDP stock notice.
   Country + flag come from GeoJS (client-side IP geolocation: no key, CORS-enabled),
   cached in localStorage for 24h. This replaces the old behaviour where the country
   came from Shopify Markets (localization.country), which only resolves correctly for
   visitors inside a configured market and otherwise shows the primary-market country
   (e.g. a Brazilian visitor saw "Austria"). If the geo lookup fails, it FALLS BACK to
   the server-rendered Shopify value (data-iso / [data-country]) → no regression.
   Flag uses flagcdn raster (w20/w40) so it renders on EVERY platform incl. Windows
   desktop (where flag emojis fall back to letters); emoji fallback if the image fails.
   External asset → survives the theme's product-column rebuild (which can strip inline
   scripts); re-applies on multiple events + retries. */
(function () {
  var GEO_URL = 'https://get.geojs.io/v1/ip/country.json';
  var LS_KEY  = 'targa_geo_v1';
  var TTL     = 24 * 60 * 60 * 1000; // 24h

  function emoji(iso) {
    if (!iso || iso.length !== 2) return '';
    try {
      var a = iso.toUpperCase().charCodeAt(0) - 65 + 0x1F1E6;
      var b = iso.toUpperCase().charCodeAt(1) - 65 + 0x1F1E6;
      return String.fromCodePoint(a, b);
    } catch (e) { return ''; }
  }

  function setFlag(f, iso) {
    var code = (iso || '').toLowerCase();
    if (!/^[a-z]{2}$/.test(code)) { f.textContent = ''; f.style.display = 'none'; return; }
    f.style.display = 'inline-flex';
    f.style.alignItems = 'center';
    f.style.verticalAlign = 'middle';
    var img = new Image();
    img.width = 20; img.height = 15; img.alt = '';
    img.loading = 'lazy'; img.decoding = 'async';
    img.style.display = 'block';
    img.style.height = '12px';
    img.style.width = 'auto';
    img.style.borderRadius = '2px';
    img.style.boxShadow = '0 0 0 1px rgba(0,0,0,.10)';
    img.onerror = function () {
      var e = emoji(iso);
      if (e) { f.textContent = e; f.style.fontSize = '13px'; }
      else { f.style.display = 'none'; }
    };
    img.src = 'https://flagcdn.com/w20/' + code + '.png';
    img.srcset = 'https://flagcdn.com/w40/' + code + '.png 2x';
    f.textContent = '';
    f.appendChild(img);
  }

  // Paint one notice element. Only re-renders the flag when the ISO actually changes
  // (avoids re-appending the <img> on every pass). Country name updated when provided.
  function paint(el, iso, name) {
    if (!iso || !/^[A-Za-z]{2}$/.test(iso)) return;
    iso = iso.toUpperCase();
    if (el.getAttribute('data-flag-iso') !== iso) {
      var f = el.querySelector('[data-flag]');
      if (f) setFlag(f, iso);
      el.setAttribute('data-flag-iso', iso);
    }
    if (name) {
      var c = el.querySelector('[data-country]');
      if (c && c.textContent.trim() !== name) c.textContent = name;
    }
  }

  function paintAll(iso, name) {
    document.querySelectorAll('.targa-stock').forEach(function (el) {
      paint(el, iso || el.getAttribute('data-iso'), name);
    });
  }

  function cached() {
    try {
      var o = JSON.parse(localStorage.getItem(LS_KEY) || 'null');
      if (!o || !o.iso) return null;
      if ((Date.now() - (o.ts || 0)) > TTL) return null;
      return o;
    } catch (e) { return null; }
  }

  // Normalise GeoJS payload (field naming differs across endpoints).
  function parseGeo(d) {
    if (!d) return null;
    var iso = '';
    if (d.country_code && /^[A-Za-z]{2}$/.test(d.country_code)) iso = d.country_code;
    else if (d.country && /^[A-Za-z]{2}$/.test(d.country)) iso = d.country;
    if (!iso) return null;
    var name = '';
    if (d.name && d.name.length > 2) name = d.name;
    else if (d.country && d.country.length > 2) name = d.country;
    else if (d.country_name) name = d.country_name;
    return { iso: iso.toUpperCase(), name: name };
  }

  // 1) Instant paint: cached real geo if fresh, else the server-rendered fallback flag.
  function initialPaint() {
    var c = cached();
    if (c) { paintAll(c.iso, c.name); return; }
    document.querySelectorAll('.targa-stock[data-iso]').forEach(function (el) {
      paint(el, el.getAttribute('data-iso'), null);
    });
  }

  // 2) Real geo-IP lookup → override + cache.
  function fetchGeo() {
    if (cached() || !window.fetch) return;
    fetch(GEO_URL, { mode: 'cors', credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var g = parseGeo(d);
        if (!g) return;
        try { localStorage.setItem(LS_KEY, JSON.stringify({ iso: g.iso, name: g.name, ts: Date.now() })); } catch (e) {}
        paintAll(g.iso, g.name);
      })
      .catch(function () {});
  }

  function run() { initialPaint(); fetchGeo(); }

  run();
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
  setTimeout(run, 400); setTimeout(run, 1200);
})();
